module.exports = "data:font/woff2;base64,"